import moment from "moment";

export const convertFormater = (val) => {
  return moment(val).format("YYYY-MM-DD");
};

export const calanderDateFormater = (val) => {
  return moment(val).format("DD MMM 'YY");
};

export const numDifferentiation = (value) => {
  var val = Math.abs(value);
  if (val >= 10000000) {
    val = (val / 10000000).toFixed(2) + " Cr";
  } else if (val >= 100000) {
    val = (val / 100000).toFixed(2) + " L";
  } else if (val >= 1000) {
    val = (val / 1000).toFixed(2) + " K";
  }
  return val;
};

export const addDays = (startDate, day) => {
  let addDays = moment(startDate, "YYYY-MM-DD").add(day, "days").toDate();
  // let formated = moment(addDays).format("DD-MM-YYYY");
  return addDays;
};

export const getDiffBtnDates = (start, end) => {
  var startDate = moment(start, "YYYY-MM-DD");
  var EndDate = moment(end, "YYYY-MM-DD");
  let dateDiff = moment.duration(EndDate.diff(startDate)).asWeeks();
  return dateDiff;
};

export const CompareDate = (orderDate, tradeDate, according) => {
  //Note: 00 is month i.e. January
  var dateOne = new Date(orderDate); //Year, Month, Date
  var dateTwo = new Date(tradeDate); //Year, Month, Date
  if (according === "smallerDate") {
    if (dateOne > dateTwo) {
      // alert(dateTwo);
      return dateTwo;
    } else {
      // alert(dateOne);
      return dateOne;
    }
  } else {
    if (dateTwo > dateOne) {
      return dateTwo;
    } else {
      return dateOne;
    }
  }
};

export const formatWeekDay = (day) => {
  console.log(day);
};
